import * as React from 'react';
import { imageBaseURL } from '../constants/CommonConstants';
import PropTypes from 'prop-types';

export class MarqueeComponent extends React.Component {

    getCustomCTAColors(ctaDetails, colorFor) {
        if(ctaDetails.colors) {
            if((colorFor === 'title' || colorFor === 'sub-title' ) && ctaDetails.colors.titleAndSubTitle && ctaDetails.colors.titleAndSubTitle !== '') {
                return { color: ctaDetails.colors.titleAndSubTitle };
            } else if(colorFor === 'ctaButton' && ctaDetails.colors.ctaButton && ctaDetails.colors.ctaButton !== '') {
                return {
                    backgroundcolor: ctaDetails.colors.ctaButton,
                    color: ctaDetails.colors.ctaButtonText
                };
            }
        }

        return {};
    }

    renderResponsiveImages(responsiveImages, defaultImage, altText) {
        return (
            <picture>
                {
                    responsiveImages && responsiveImages.length > 0 ?
                        responsiveImages.map((image, index) => <source key={`responsiveImage-${index}`} media={`(max-width:${image.width}px)`} srcSet={imageBaseURL + image.imageURL} />) : null
                }
                <img alt={altText || ''} src={imageBaseURL + defaultImage} />
            </picture>
        );
    }

    renderMarqueeCTA(ctaDetails) {
        if(!ctaDetails) return null;

        return(
            <div className={`marquee-cta${ctaDetails.hideOnMobile ? ' hide-on-mobile' : ''}`}>
                <h2 className={'marquee-title'} style={this.getCustomCTAColors(ctaDetails, 'title')}>{ctaDetails.title}</h2>
                {ctaDetails.subTitle && ctaDetails.subTitle !== '' ? <div className={'marquee-sub-title hide-on-mobile'} style={this.getCustomCTAColors(ctaDetails, 'sub-title')}>{ctaDetails.subTitle}</div> : null}
                {ctaDetails.ctaLink && ctaDetails.ctaLink !== '' ?
                    <div className="btn">
                        <a className={'uig-button uig-primary-button'} style={this.getCustomCTAColors(ctaDetails, 'ctaButton')} href={ctaDetails.ctaLink}>
                            {ctaDetails.ctaLinkText && ctaDetails.ctaLinkText !== '' ? ctaDetails.ctaLinkText : 'GET STARTED'} <span className={'hide-on-desktop'}>&gt;</span>
                        </a>
                    </div> : null}
            </div>
        );
    }

    render() {
        if(!this.props.marqueeDetails || !this.props.marqueeDetails.defaultImage) return null;

        return (
            <div className={'marquee-wrapper'}>
                <div className={'marquee'}>
                    {this.renderResponsiveImages(this.props.marqueeDetails.responsiveImages, this.props.marqueeDetails.defaultImage, this.props.marqueeDetails.altText)}
                </div>
                {this.renderMarqueeCTA(this.props.marqueeDetails.cta)}
                {this.props.children}
            </div>
        );
    }
}

MarqueeComponent.propTypes = {
    marqueeDetails: PropTypes.object.isRequired,
    children: PropTypes.any
};

MarqueeComponent.defaultProps = {
    children: null
};
